import { render } from "./TrashIcon.vue?vue&type=template&id=e131cd32&scoped=true"
import script from "./TrashIcon.vue?vue&type=script&lang=js"
export * from "./TrashIcon.vue?vue&type=script&lang=js"

import "./TrashIcon.vue?vue&type=style&index=0&id=e131cd32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e131cd32"]])

export default __exports__